import BaseModel from '@kakadu-dev/base-frontend-helpers/models/BaseModel';
import { City } from "../City";
import { Country } from "../Country";
import { Customer } from "./Customer";
/**
 * Customer delivery address model
 */

export class DeliveryAddress extends BaseModel {
  constructor(...args) {
    super(...args);

    this.getId = () => {
      return Number(this.model.id);
    };

    this.getCustomerId = () => {
      return Number(this.model.customerId);
    };

    this.getCityId = () => {
      return Number(this.model.cityId);
    };

    this.getStreet = () => {
      return this.model.street;
    };

    this.getHouse = () => {
      return this.model.house;
    };

    this.getBlock = () => {
      return this.model.block;
    };

    this.getApartment = () => {
      return this.model.apartment;
    };

    this.isDefault = () => {
      return Boolean(this.model.isDefault);
    };

    this.getCreatedAt = () => {
      return this.model.createdAt;
    };

    this.getUpdatedAt = () => {
      return this.model.updatedAt;
    };

    this.getAttributes = () => {
      const {
        createdAt,
        updatedAt,
        ...attributes
      } = this.model;
      return attributes;
    };

    this.getCustomer = customer => {
      return this.getRelation('customer', Customer, customer);
    };

    this.getCountry = country => {
      return this.getRelation('country', Country, country);
    };

    this.getCity = city => {
      return this.getRelation('city', City, city);
    };
  }

  /**
   * Create delivery address
   *
   * @param {object} object
   *
   * @return {DeliveryAddress}
   */
  static create(object) {
    return super.create(object);
  }
  /**
   * Create list delivery addresses
   *
   * @param {object} objects
   *
   * @return {Array.<DeliveryAddress>}
   */


  static createList(objects) {
    return super.createList(objects);
  }
  /**
   * Map delivery addresses
   *
   * @param {Array.<object>} objects
   * @param {function(DeliveryAddress): undefined} callback
   *
   * @return {Array.<object>}
   */


  static map(objects, callback) {
    return super.map(objects, callback);
  }
  /**
   * Get model id
   *
   * @return {number}
   */


}